<style lang="scss" scoped>
 /deep/.custom-select .el-input__inner{
    height: auto !important;
    background-color: #fafafa;
    border: none;
}
.notRelease{
    color:#9d9d9d;
}
.close{
    color:#000000;
}
.yifabu{
    color:#3296fa;
}
.yifankui{
    color:#00c075;
}
.yichehui{
    color:#ff5555;
}
.feedbackModify{
    color:#fdc989;
}
.feedbackPass{
    color:#99e6c8;
}
.el-range-editor.el-input__inner{
    width: 100%;
    border: 0px solid #dcdfe6;
}
.timeIsEdit{
    color:#507dac;
}
.noTimeIsEdit{
    color:#323232
}
.but-fill-time{
    position: absolute;
    top: 18px;
    right: 0px;
}
.but-fill-time img{
    width: 20px;
    height: 20px;
}
</style>

<template>
   <!--  -->
    <el-table-column
        :prop="col.prop"
        :label="col.label"
        align="center"
        v-if="!col.show"
        :fixed="col.fixed"
        :min-width="width"
        :sortable="col.sortable"
		:render-header="col.renderHeader"
		:sort-method="col.sortMethod"
        :show-overflow-tooltip="editField.indexOf(col.prop) == -1 || col.type=='pop'"
        >
        <template slot="header" slot-scope="slot" >
            <span :data-id="slot.$index" v-if="editField.indexOf(col.prop) != -1 && !col.isbitian">
                <span style="color:#ff0101">*</span>
                {{col.label}}
            </span>
            <span v-else>{{col.label}}</span>
        </template>
        <template slot-scope="scope" >
            <!-- !isAdmin非管理员界面 -->
            <!--销量只能输入整数-->
            <!--2位小数-->
            <el-input @paste.native="onPaste(scope.$index,col.prop)" v-if="editField.indexOf(col.prop) != -1 && !isAdmin && !isNoEditRow && !col.noNeedControl && !col.isData" type="text"  @keydown.native="channelInputLimit($event,scope.row,col.prop,col)"  @focus='getfocus(scope,$event,col,scope.$index)' @blur="dblur($event)"  v-on:input="inputFunc(scope.$index, scope.row,col.prop,$event)" :value="strGetVal(col.prop,scope)"   placeholder="请输入" size="small"/>
            
            <span v-if="editField.indexOf(col.prop) == -1  && !isAdmin && !isNoEditRow && customField.indexOf(col.prop) == -1"> {{strGetVal(col.prop,scope)}}</span>
        </template>
        <template v-if="col.children && !col.show">
            <digital-column
                v-for="(item, index) in col.children"
                :key="index"
                :col="item"
                :unEditRow="unEditRow"
                :editField="editField"
                :pasteField="pasteField"
                :height="height" 
                :maxLength="maxLength"
                :formatterList="formatterList"
                :tableData="tableData"
                @modification="modificationa"
				@loseFocus="loseFocus"
                @pasteData="pasteData"
                :width="item.width">
            </digital-column>
        </template>
    </el-table-column>
</template>
<script>
import { money,numberFormat } from "@/utils/filter.js"
export default {
    name: "digital-column-taxes",
    data() {
        return {
            createTime:"",
            sth:"",
            field:[],
            tempkey:"",
            fuShu: false,
            fushuNumber: "",
            currentCol:"",
            currentIndex:"",
            tLength:"",//table长度
            focusIndex:"",//聚焦在哪一行
            focusProp:""
        };
    },
    props: {
        isNoEditRow:{
            type:Boolean
        },
        isAdmin:{
            type:Boolean
        },
        tableData:{
            type: Array,
            default: () => {
                return []
            }
		},
        col: {
            type: Object
        },
        completeFlagObj:{
            type: Object
        },
        editField:{
            type: Array,
            default: () => {
                return []
            }
        },
        customField:{
            type: Array,
            default: () => {
                return []
            }
        },
        pasteField:{
            type: Array,
            default: () => {
                return []
            }
        },
        unEditRow:{
            type: Array,
            default: () => {
                return []
            }
        },
        formatterList:{
            type: Array,
            default: () => {
                return []
            }
		},
		height:{
			type: String
		},
		formatteColumn:{
			type: Object
        },
        width:{
			type: String
		},
		maxLength:{
			type: Number,
			default: function(){
				return 15
			}
		},
    },
    methods: {
          substrClipTest(clipText,data){
            let index = clipText.indexOf("\r\n");
            if(index > -1){
                let rowResult = clipText.slice(0,index).split("\t");
                data.push(rowResult);
                let text = clipText.slice(index+2);
                if(text.indexOf("\r\n") > -1){
                     this.substrClipTest(text,data);
                }
                return data;
            }
        },
        onPaste(index,prop){
            //如果不满足 黏贴列表传空pasteField=[]
            if(this.pasteField&&this.pasteField.length>0){
                navigator.clipboard.readText().then((clipText)=>{//
                    //  console.log(clipText)
                    if(clipText.indexOf("\r\n") > 0){
                        //1.剪贴版结果集
                        let result = this.substrClipTest(clipText,[]); 
                        let editData = []; 
                        //2.结果集处理成对象 类型，字段名，内容
                        result.forEach((value,key)=>{
                            let data = [];
                            let startVal =false,i=0;
                            this.pasteField.forEach((editValue,editKey)=>{
                                if((editValue.name == prop || startVal)&&value[i]!=undefined){//2个字段相等就开始， 直到数组遍历完
                                    startVal =true;
                                    let obj={type:editValue.type,key:editValue.name,value:value[i],isCover:editValue.isCover};
                                    data.push(obj);
                                    i++;
                                }
                            });
                            editData.push(data);
                        });
                        // console.log("结果集",editData)
                        this.tLength=this.tableData.length
                        //记录每个编辑得值。 页面只处理这些编辑得
                        let pasteDataLocal=[];
                        //3.结果集 写入到表里面
                        editData.forEach((value,key)=>{
                            value.forEach((innerValue,innerKey)=>{
                                if(index+key<this.tLength){
                                    //每种类型的处理
                                    if(innerValue.isCover){
                                        if(innerValue.type == "number"){
                                            this.tableData[index+key][innerValue.key] = parseFloat(innerValue.value);
                                        }else if(innerValue.type == "date"){
                                            this.tableData[index+key][innerValue.key] = moment(innerValue.value).valueOf();
                                        }else{
                                            this.tableData[index+key][innerValue.key] = innerValue.value;
                                        }
                                        // console.log(index+key ,innerValue.key);
                                        pasteDataLocal.push({"key":index+key,"name":innerValue.key});
                                    }
                                }
								
                            });
                        });
                        //公共处理
                        this.$emit("pasteData",{tableData:this.tableData,index:index,prop:prop,result:result,pasteDataLocal:pasteDataLocal});
                    }
                });
            }else{
                 navigator.clipboard.readText().then((clipText)=>{//
                    //  console.log(clipText)
                    if(clipText.indexOf("\r\n") > 0){
                        //1.剪贴版结果集
                        let result = this.substrClipTest(clipText,[]); 
                        //自己处理
                        this.$emit("pasteData",{tableData:this.tableData,index:index,prop:prop,result:result});
                    }
                });
            }
            
        },
        pasteData(e){
            this.$emit("pasteData",e);
        },
        chooseTime(index,row,prop){
            this.$emit("openDialog",{index:index,row:row,prop:prop});
        },
        //失去焦点
		loseFocus(e){
			this.$emit("loseFocus", this.tableData);
		},
		//input 监听
		modificationa(e){
			this.$emit("modification",e);
        },
        //键盘监控
        getFocusKeydown(e){
            let that = this;
            $(e.target).keydown(function(e) {
                if (e.ctrlKey && (e.keyCode == 86)){
                    // console.log(that.currentCol,"Document catch Ctrl+V")
                    that.onPaste(that.currentIndex,that.currentCol);
                } 
                
            });
        },
        // //获取到焦点
        // getfocus(e,col,index,x){
        //      this.focusIndex = index;
        //     this.focusProp = col.prop;
        //     e.currentTarget.value = this.delcommafy(e.currentTarget.value);
        //     this.currentCol =col.prop;
        //     this.currentIndex =index;
        //     this.getFocusKeydown(e);
        //     if(x){
        //         e.$el.children[0].className = 'get-focus el-input__inner';
        //     }else{
        //         e.target.className = 'get-focus el-input__inner';
        //     }
            
        // },
        //获取到焦点
        getfocus(scope,e,col,index,x){
            let that =this;
            let rowprop = eval('scope.row.'+col.prop );
            // let rowprop =e.target.value;
            e.target.type="number";
            this.focusIndex = index;
            this.focusProp = col.prop;
            this.currentCol =col.prop;
            this.currentIndex =index;
            this.getFocusKeydown(e);
            if(x){
                e.$el.children[0].className = 'get-focus el-input__inner';
            }else{
                e.target.className = 'get-focus el-input__inner';
            }
            //  console.log("3",rowprop)
            // that.$nextTick(()=>{
            //     setTimeout(()=>{
                    e.target.type="text";
                    // console.log("1",rowprop)
                    if(rowprop){
                        //  console.log("2",rowprop)
                        e.target.value = that.delcommafy(rowprop);
                    }
                    e.target.selectionStart = e.target.value.length;
            //     },30);
            // });            
        },
         //失去焦点
        dblur(e,x){
            e.target.type="text";
            e.target.value = this.commafy(e.target.value);
            if(x){
                e.$el.children[0].className = 'el-input__inner';
            }else{
                e.target.className = 'el-input__inner';
            }
            this.$emit("loseFocus", this.tableData);
        },
        channelInputLimit(e,row,prop,col){
            //  e.currentTarget.value = this.delcommafy(e.currentTarget.value);//v.30千符号
            // col.isInteger?value=value.replace(/^[0-9]*[1-9][0-9]*$/g,''):
            let rowprop = eval('row.'+prop );
            let key = e.key;
            let ctrlKey=e.ctrlKey
            //限制大小 
            let maxVal =rowprop+""+key;
            if(col.max&&col.max<maxVal&& key !== "Backspace"){
                e.preventDefault ? e.preventDefault() : (e.returnValue = false);
                return false;
            }
            //限制长度
            let maxLength = this.maxLength;
            if(col.maxLength){
                maxLength = col.maxLength;
            }
            if((rowprop+"").length> maxLength && key !== "Backspace"){
                e.preventDefault ? e.preventDefault() : (e.returnValue = false);
                return false;
            }
            //小数点前十五位判断
            let index = (rowprop+"").indexOf(".");
            let selectionStart=e.target.selectionStart;
            if(key === "Backspace"){
                selectionStart = selectionStart-1;
            }
            if((index == -1 && (rowprop+"").length > maxLength-3 && key !== "Backspace" && key !== ".")|| (index>-1&&index == maxLength-2&&index>=selectionStart && key !== "Backspace")){
                e.preventDefault ? e.preventDefault() : (e.returnValue = false);
                return false;
            }
            //整数的时候 不能输入小数点
            // console.log(col.isInteger && key === '.',col.isInteger , key === '.',key )
            if(col.isInteger && (key === '.'|| key === 'Decimal')){
              
                e.preventDefault ? e.preventDefault() : (e.returnValue = false);
                return false;
            }
            var reg = /^\d+$|^\d*\.\d+$/g;
            if (key === '.' || key === 'Decimal' ) {
                if(  rowprop == "" || this.tempkey =='.' || rowprop.toString().indexOf('.') !=-1){
                      console.log(222)
                   e.preventDefault ? e.preventDefault() : (e.returnValue = false);
                    return false;
                }else{
                      console.log(111)
                    this.tempkey = key;
                    return true;
                }
            }else if(reg.test(key) || key === "Backspace" || (row.isFuShu && (key === 'Process' || key==='-'))){
                this.tempkey = "";
                return true;
            }else{
                e.preventDefault ? e.preventDefault() : (e.returnValue = false);
                return false;
            }
        },
        //输入监听 index下标 row 一行数据 prop 属性 e值 新数组
        inputFunc(index,row,prop,e){
            console.log('row',row);
			let that = this;
            e = numberFormat(e,{ start:11,end:4});
            eval('row.'+prop+"= e" );
            if(that.tableData !=undefined){
                var new_arr = JSON.parse(JSON.stringify(that.tableData));
                if(row["defaultIndex"]>=0){
                    new_arr[row.defaultIndex] = row;
                }else{
                    new_arr[index] = row;
                }
                //回掉事件
                that.$emit("modification", {index:index,row:row,prop:prop,val:e,tableData:new_arr});
            }
        },
        //去除千分位
        delcommafy(num){
            if((num+"").trim()==""){
                return num;
            }
            num = num+"";
            num=num.replace(/,/gi,'');
            console.log(num)
            return num;
        },
        // 数字格式转换成千分位
        commafy(num){
            if((num+"").trim()=="" || isNaN(num) || num == null){
                return num;
            }
            num = num+"";
            if(/^.*\..*$/.test(num)){
            let pointIndex =num.lastIndexOf(".");
            let intPart = num.substring(0,pointIndex);
            let pointPart =num.substring(pointIndex+1,num.length);
            intPart = intPart +"";
                let re =/(-?\d+)(\d{3})/
                while(re.test(intPart)){
                intPart =intPart.replace(re,"$1,$2")
                }
            num = intPart+"."+pointPart;
            }else{
                num = num +"";
                let re =/(-?\d+)(\d{3})/
                while(re.test(num)){
                num =num.replace(re,"$1,$2")
                }
            }
            return num;
        },
        strGetVal(row,scope,index){
            if(this.formatterList && this.formatterList.indexOf(scope.column.property) != -1) {//日期格式化
				let dataStr = eval('scope.row.'+row );
				if( dataStr ){
					if ( row == "reviewTime" || row == "publishDatetime" ) {
						return moment(parseInt(dataStr)).format('YYYY-MM-DD HH:mm');
					}else{
						return moment(parseInt(dataStr)).format('YYYY-MM-DD');
					}
				}else{
					return "";
				}
			}else if(this.formatteColumn && this.formatteColumn.name.indexOf(scope.column.property) != -1){
				return  this.formatteColumn.list[eval('scope.row.'+row )-1];
			}else if(row == "sfSales"){
                if(scope.row.sfSales){
                    if(scope.row.sfSales == "0"){
                        return "未上市";
                    }else{
                        return "已上市";
                    }
                }
            }else if(row == "assetType"){
                const assetsTypeList =  this.$store.state.init.configInfo.unsetupAssetType
                const find = assetsTypeList.find(v=>v.id == scope.row.assetType)
                if(find){
                    return find.name
                } else {
                    return ""
                }
            } else if(row == "businessModel"){
                const businessModelList =  this.$store.state.init.configInfo.businessModel
                const find = businessModelList.find(v=>v.id == scope.row.businessModel)
                if(find){
                    return find.name
                } else {
                    return ""
                }
            }else if(row.slice(0,10) == "tongBiRise" || row.slice(0,10)=="huanBiRise"){
                if(row.slice(0,13) == "tongBiRisePur" || row.slice(0,13)=="huanBiRisePur"){
                    if(scope.row[row]){
                        return Number(scope.row[row]*100).toFixed(2)
                    }else{
                        return "/"
                    }
                }else{
                    if(scope.row[row]){
                        return scope.row[row]
                    }else{
                        return "/"
                    }
                }
            } else if (row == "reviewStatus") {
				let val = ""
                if(scope.row.reviewStatus ==  null) return ""
				switch (scope.row.reviewStatus) {
					case "0":
						val = "未审核"
						break;
					case "1":
						val = "不通过"
						break;
					case "2":
						val = "已通过"
						break;
					case "未反馈":
						val = ""
						break;
					case "通过":
						val = "通过"
						break;
					case "未通过":
						val = "未通过"
						break;
					default:
						val = "无"
						break;
				}
				return val	
			}else{
                if((this.focusIndex == scope["$index"] && this.editField.indexOf(this.focusProp) != -1) || row == 'materialCode'|| row == 'projectCode'){
                    return  eval('scope.row.'+row);
                }else{
                    // console.log('scope.row.'+row,eval('scope.row.'+row ),this.commafy(eval('scope.row.'+row )));
                    return this.commafy(eval('scope.row.'+row ))
                }
            }
        },
    }
};
</script>